mutation ApprovalTestResultDelete($input: ApprovalTestResultDeleteInput!) {
  approvalTestResultDelete(input: $input) {
    entityDeletes {
      id
      rowTimestamp
    }
  }
}
